import { useEffect, useState } from 'react';
import { readFlag, userKey, writeFlag } from './storage';

// The Help tips switch (Help & tours panel). Off hides the longer help tips
// (title + explanation); short labels like "Close Esc" always show. Saved per
// signed-in user.
export const HELP_TIPS_KEY = 'pp_forms_help_tips';

const listeners = new Set();

export const isHelpTipsEnabled = () => readFlag(userKey(HELP_TIPS_KEY)) !== '0';

export const setHelpTipsEnabled = (on) => {
  const value = !!on;
  writeFlag(userKey(HELP_TIPS_KEY), value ? '1' : '0');
  listeners.forEach((fn) => fn(value));
};

export const subscribeHelpTips = (fn) => {
  listeners.add(fn);
  return () => {
    listeners.delete(fn);
  };
};

export const useHelpTipsEnabled = () => {
  const [on, setOn] = useState(isHelpTipsEnabled);
  useEffect(() => subscribeHelpTips(setOn), []);
  return [on, setHelpTipsEnabled];
};
